import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] text-red-500 flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-red-600" />
    {children}
  </p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display font-extrabold uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] ${className}`}>
    {children}
  </h2>
);
